import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPatientDataModel } from 'src/app/model/common/patient-data';
import { GeneralDetailModel } from 'src/app/model/general/detail';
import { GeneralConsultWrapperService } from './wrapper.service';

@Component({
  selector: 'ms-consult-wrapper',
  templateUrl: './wrapper.component.html',
})
export class GeneralConsultWrapperComponent extends BaseComponent {
  @Input() turn = -1;
  @Input() patient = -1;
  @Input() readonly = false;
  @Input() patientData: CommonPatientDataModel = {};
  @Output() patientDataChange = new EventEmitter<CommonPatientDataModel>();
  detail: GeneralDetailModel = {};

  constructor(protected service: GeneralConsultWrapperService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service
        .loadConsultDetail(this.turn)
        .subscribe((detail) => (this.detail = detail)),
      this.service
        .loadPatientData(this.patient)
        .subscribe((patientData) => this.patientDataChange.emit(patientData))
    );

    if (!this.readonly) {
      this.subscriptions.push(
        this.service.isSaving().subscribe((saving) => {
          if (saving) {
            this.subscriptions.push(
              this.service
                .save(this.turn, this.detail)
                .subscribe((detail) => (this.detail = detail))
            );
            this.subscriptions.push(
              this.service
                .savePatientData(this.patientData)
                .subscribe((patientData) => (this.patientData = patientData))
            );
          }
        })
      );
    }
  };
}
